import React, { ElementType, ReactNode } from 'react'

import Box from 'components_new/atoms/Box'

interface VisuallyHiddenProps {
  children: ReactNode
  component?: ElementType<any>
  id?: string
}

/**
 * The VisuallyHidden component keeps its content
 * out of the visual layout while leaving it in the
 * accessibility tree, so that screen readers can
 * announce text that sighted users get from the
 * surrounding graphics.
 */

const VisuallyHidden = (props: VisuallyHiddenProps) => {
  const { children, component = 'span', id } = props

  return (
    <Box
      component={component}
      id={id}
      sx={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
      }}
    >
      {children}
    </Box>
  )
}

VisuallyHidden.displayName = 'VisuallyHidden'
export default VisuallyHidden
